import type { Plugin } from 'vue'
import { widgets } from '#src/vue/forms/widgets.mts'
import { defineAsyncComponent } from 'vue'

const InlineForm = defineAsyncComponent(() => import('#src/vue/forms/DjangoFormInline.vue'))
const RemoteForm = defineAsyncComponent(() => import('#src/vue/forms/DjangoForm.vue'))
const Formset    = defineAsyncComponent(() => import('#src/vue/forms/DjangoFormset.vue'))

/***
 * allows the use of form widgets and the DjangoFormInline component.
 **/
export default {
  install (app) {
    Object.entries(widgets).forEach(
      ([key, component]) => app.component(key, component)
    )

    app
      .component('DjangoFormInline', InlineForm)
      .component('DjangoForm', RemoteForm)
      .component('DjangoFormset', Formset)
  }
} as Plugin<[]>
